import { render, staticRenderFns } from "./shell-icon.vue?vue&type=template&id=e1b831cc&scoped=true&"
import script from "./shell-icon.vue?vue&type=script&lang=ts&"
export * from "./shell-icon.vue?vue&type=script&lang=ts&"
import style0 from "./shell-icon.vue?vue&type=style&index=0&id=e1b831cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b831cc",
  null
  
)

export default component.exports